import { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, IconButton } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Public from "@material-ui/icons/Public";

import { SelectedRegion, SearchResult, RegionSearchData } from "@/utilities/types/search";

import { resultStyles } from "./ResultStyles";


interface RegionResultProps {
    index: number,
    isMultiClient: boolean
    result: SearchResult<RegionSearchData>,
    onSelect: (client_id: SelectedRegion) => void;
}

const RegionResult:React.FC<RegionResultProps> = ({ index, result, isMultiClient, onSelect } ) => { const classes = resultStyles();

    const handleOnClick = () => {
        onSelect( { id: result.source.id, name: result.source.name });
    };

    return (
        <ListItem
            key={index}
            data-testid={"region-result"}
            className={classes.item}
            onClick={handleOnClick}
            button
        >
            <ListItemIcon>
                <Public color="action" />
            </ListItemIcon>
            <ListItemText primary={isMultiClient ? `${result.source.name} - ${result.source.client_name}` : result.source.name}/>
            <ListItemSecondaryAction>
                <IconButton onClick={handleOnClick}><Add /></IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
};

export default RegionResult;
